<div class="h-full flex justify-between items-center text-gray-7 px-3">
   <p>
    &copy; {{year}} {{tenant.getTenantName()}} {{" "}} {{" "}} &nbsp;  {{"
    "}} {{" "}} &nbsp; All rights reserved.
   </p>
<img alt="CCMS Logo with Text" class="h-10 cursor-pointer" [src]="footerImageUrl">
</div>
